/** Semáforo do Fator de Ajuste (FA) da CCEE — regra de negócio REAL (não é
 * mock; morava em mockDataMesa.ts e saiu de lá no fail-closed do incidente
 * 02/08 pra nenhum componente de produção precisar importar o arquivo de
 * mocks). Limiares: <=0,3 verde · <=0,5 amarelo · acima vermelho. */
export function faCor(fa: number): "green" | "yellow" | "red" {
  if (fa <= 0.3) return "green";
  if (fa <= 0.5) return "yellow";
  return "red";
}
